import { SanityProductFeaturesSection } from "@sourceful/shared-types/src/sanity/layouts/productFeaturesSection";
import ProductFeaturesList from "../../../views/productDetailPage/productFeatures/ProductFeaturesListSection";
import BasePageSection from "../BasePageSection";

interface ProductFeaturesSectionProps {
  section: SanityProductFeaturesSection;
}

export const ProductFeaturesSection = ({ section }: ProductFeaturesSectionProps) => {
  return (
    <BasePageSection section={section} minHeight={"auto"}>
      <ProductFeaturesList featureSections={section.productFeatureSections || []} />
    </BasePageSection>
  );
};

export default ProductFeaturesSection;
